import React, { useEffect } from "react";
import { useObserver } from "mobx-react";
import { useState } from "react";
import { useStores } from "../../store";
import { AiFillCloseCircle } from "react-icons/ai";
import { RiRobot2Line } from "react-icons/ri";

import {
  MdOutlineCorporateFare,
  MdOutlineQuestionAnswer,
} from "react-icons/md";
import { BsPersonVideo3, BsPersonWorkspace } from "react-icons/bs";
import { BsBuildings } from "react-icons/bs";
import {
  interviewsList,
  interviewsProList,
} from "../../helpers/constantVariables";
import { toJS } from "mobx";
import cup from "../../assests/cup.png";
import { useNavigate } from "react-router-dom";
import {
  HiOutlineUsers,
} from "react-icons/hi2";
import { HiOutlineBriefcase } from "react-icons/hi2";
import { FaCode } from "react-icons/fa";
import { SlSpeech } from "react-icons/sl";
import { VscHubot } from "react-icons/vsc";

export default function Create({ popUpInitialValue, handlePopup }) {
  const { PopupStore, UserStore, InterviewStore } = useStores();
  // const [isClicked, setIsClicked] = useState(true);

  const closeThisPopUP = () => {
    PopupStore.setCreateInterview(false);
    PopupStore.setCompanyInterview(false);
    handlePopup();
  };

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div
          onClick={() => closeThisPopUP}
          className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed  inset-0  bg-bg3 z-50 shadow-lg overflow-y-auto no-scrollbar  flex flex-col justify-center rounded items-center md:w-[85%] lg:w-[85%] w-[90%] h-[85vh] m-auto "
          >
            <div className="flex flex-col  items-center w-[100%] h-full py-5 absolute left-10">
              <h1 className="gil-med text-2xl md:mt-0 lg:mt-0 mt-[10%]">
                Choose your interview type
              </h1>
              <AiFillCloseCircle
                className="text-primary absolute text-2xl cursor-pointer  top-2 right-12"
                onClick={closeThisPopUP}
              />
              {/* <div className="flex items-center justify-center mt-3 gap-10">
                <button
                  onClick={() => {
                    setIsClicked(true);
                    if (PopupStore.companyInterview) {
                      const company_interviews = freeInterviews.filter(
                        (interview) => interview.company
                      );
                      setinterviews(company_interviews);
                    } else {
                      setinterviews(freeInterviews);
                    }
                    setInterviewListWithModels(interviewsList);
                  }}
                  className={` ${
                    isClicked
                      ? "bg-primary text-white"
                      : "bg-white text-primary border border-primary"
                  } h-10 w-20 bg-primary rounded-xl `}
                >
                  Free
                </button>
                <button
                  onClick={() => {
                    setIsClicked(false);
                    setinterviews(proInterviews);
                    setInterviewListWithModels(interviewsProList);
                  }}
                  className={` ${
                    !isClicked
                      ? "bg-primary text-white"
                      : "bg-white text-primary border border-primary"
                  } h-10 w-20 bg-primary items-center justify-center flex gap-2 rounded-xl `}
                >
                  <BsStars />
                  Pro
                  
                </button>
              </div> */}
              {/* {isClicked ? ( */}
              <InterviewList className="absolute right-10" />
              {/* ) : (
                <div className="flex flex-wrap justify-center gap-4 pb-3 mt-5">
                  {interviews
                    .sort((a, b) => a.sort - b.sort)
                    .map((interview, index) => (
                      <div
                        className={`md:w-[30%] lg:w-[30%] w-80 ${
                          interview.active
                            ? `hover:border-primary`
                            : `hover:border-slate-500`
                        } hover:border border shadow-sm border-primary2  p-4 rounded-xl`}
                      >
                        <h1 className="text-xl md:my-3  ">{interview.title}</h1>
                        <p className="text-sm opacity-80 h-28">
                          {" "}
                          {interview.description}
                        </p>
                        <p>Require 69 credits</p>
                        <p className="text-5xl">{interview.img}</p>
                        {interview.active ? (
                          <button
                            className="bg-primary mt-2 mx-auto w-full text-white rounded-lg px-4 text-lg py-2"
                            onClick={() => {
                              settingPopup();
                              settingInterview(index);
                            }}
                          >
                            Start Interview
                          </button>
                        ) : (
                          <button className="bg-slate-500 mt-2 mx-auto w-full text-white items-center flex justify-center gap-2 text-lg rounded-lg px-4 py-2">
                            <MdOutlineUpcoming /> Coming Soon
                          </button>
                        )}
                      </div>
                    ))}
                </div>
              )} */}
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}

export function InterviewList({ fromCompany, freeInterviews }) {
  const { PopupStore, UserStore, InterviewStore } = useStores();
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const userRole = JSON.parse(localStorage.getItem("user"))?.role?.role;

  const proInterviews = [
    {
      img: <BsPersonVideo3 />,
      title: "Basic Interview",
      id: 2, // interview id
      sort: 1,
      description:
        "Mock practice at 60% efficiency builds a solid foundation, boosting confidence and enabling initial self-assessment.",
      active: true,
      type: "basic",
    },
    // {
    //   img: <AiOutlineFileDone />,
    //   title: "Resume Based Interview",

    //   id: 2, // interview id
    //   sort: 3,
    //   description:
    //     "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    //   active: true,
    //   type: "resume",
    // },
    {
      img: <BsBuildings />,
      title: "Company Specific Interview",
      id: 4, // interview id
      sort: 4,
      description:
        "The company's interview process efficiently assesses candidates through diverse formats, providing a comprehensive evaluation of skills and cultural fit.",
      active: true,
      type: "company",
    },
    // {
    //   img: <BsBuildingCheck />,
    //   title: "Company Interview with Resume",
    //   id: 4, // interview id
    //   sort: 5,
    //   description:
    //     "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    //   active: true,
    //   type: "resume, company",
    // },
    {
      img: <BsPersonWorkspace />,
      title: "HR Interview",
      id: 8, // interview id
      sort: 6,
      description:
        "HR interview efficiently screens candidates, quickly assessing qualifications and potential job alignment based on resumes.",
      active: true,
    },
    {
      img: <RiRobot2Line />,
      title: "English Practice Bot",
      id: 6, // interview id
      sort: 8,
      description:
        "English Practice Bot helps improve speaking skills by asking questions, providing feedback on your answers.",
      active: true,
    },
    {
      img: <MdOutlineQuestionAnswer />,
      title: "Viva Interview",
      id: 9, // interview id
      sort: 7,
      description:
        "Viva Interview provides real-time practice to enhance your skills, offering interactive assessments to showcase knowledge and boost confidence for the actual session.",
      active: true,
    },
  ];
  const freeInterviews1 = [
    {
      title: "Technical Mock Interview",
      id: 2, // interview id // 2 is with resume 1 is without resume
      sort: 1,
      description:
        "Mock practice at 60% efficiency builds a solid foundation, boosting confidence and enabling initial self-assessment.",
      active: true,
      type: "basic",
      company: true,
      icon: <HiOutlineBriefcase />,
    },
    // {
    //   img: <AiOutlineFileDone />,
    //   title: "Resume Based Interview",

    //   id: 2, // interview id
    //   sort: 3,
    //   description:
    //     "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    //   active: true,
    //   type: "resume",
    // },
    {
      // img: <BsBuildings />,
      title: "Company Specific Interview",
      id: 4, // interview id // 4 is with resume  3 is without resume
      sort: 4,
      description:
        "The company's interview process efficiently evaluates candidates' skills and cultural fit through diverse formats.",
      active: true,
      type: "company",
      icon: <MdOutlineCorporateFare className="w-8 h-8" />,
    },
    // {
    //   img: <BsBuildingCheck />,
    //   title: "Company Interview with Resume",
    //   id: 4, // interview id
    //   sort: 5,
    //   description:
    //     "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    //   active: true,
    //   type: "resume, company",
    // },
    {
      img: <BsPersonWorkspace />,
      title: "HR Interview",
      id: 8, // interview id // 8 is with resume  5 is without resume
      sort: 6,
      description:
        "HR interview efficiently screens candidates, quickly assessing qualifications and potential job alignment based on resumes.",
      active: true,
      company: true,
      icon: <HiOutlineUsers className="w-8 h-8" />,
    },
    {
      img: <BsPersonWorkspace />,
      title: "Coding Interview",
      id: 10, // interview id // 10 is with resume  5 is without resume
      sort: 6,
      description:
        "A coding interview assesses programming skills and problem-solving through technical challenges.",
      active: true,
      company: true,
      icon: <FaCode />,
    },
    {
      img: <RiRobot2Line />,
      title: "English Practice Bot",
      id: 6, // interview id
      sort: 8,
      description:
        "English Practice Bot helps improve speaking skills by asking questions, providing feedback on your answers.",
      active: true,
      icon: <VscHubot className="w-14 h-14" />,
    },
    {
      img: <MdOutlineQuestionAnswer />,
      title: "Viva Interview",
      id: 9, // interview id
      sort: 7,
      description:
        "The company's interview process efficiently assesses skills and cultural fit through diverse formats.",
      active: true,
      icon: <SlSpeech />,
    },
  ];

  const [interviews, setinterviews] = useState(freeInterviews);

  const [interviewListWithModels, setInterviewListWithModels] =
    useState(interviewsList);

  function settingPopup() {
    PopupStore.setCreateInterview(false);
    if (fromCompany) {
      navigate("/company/interview-form");
    } else {
      navigate("/dashboard/meeting-creation-form");
    }
  }

  // useEffect(() => {
  //   setinterviews(freeInterviews);
  // }, [freeInterviews]);

  const settingInterview = (index) => {
    console.log(toJS(interviewListWithModels));

    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(interviewListWithModels[index])
    );
    const index1 = interviewListWithModels.findIndex(
      (interview) => interview.id === interviews[index].id
    );
    console.log("this is index", index1);
    console.log("this is index", interviewListWithModels[index1]);
    InterviewStore.setInterviewSettings(interviewListWithModels[index1]);
    localStorage.setItem(
      "interviewIndex",
      JSON.stringify(interviewListWithModels[index1])
    );
    console.log("this is store", toJS(InterviewStore.interviewSettings));

    // console.log(interviewsList[index])
    // console.log(JSON.parse(localStorage.getItem("interviewSettings")));
  };

  const settingProInterview = (index, id) => {
    setInterviewListWithModels(interviewsProList);
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(interviewsProList[index])
    );
    const index1 = interviewsProList.findIndex(
      (interview) => interview.id === id
    );
    console.log("this is index", index1);
    console.log("this is index", interviewsProList[index1]);
    InterviewStore.setInterviewSettings(interviewsProList[index1]);
    localStorage.setItem(
      "interviewIndex",
      JSON.stringify(interviewsProList[index1])
    );
    console.log("this is store", toJS(InterviewStore.interviewSettings));
  };

  useEffect(() => {
    if (PopupStore.companyInterview) {
      const company_interviews = freeInterviews.filter(
        (interview) => interview.company
      );
      console.log(company_interviews);
      setinterviews(company_interviews);
    }
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 w-full mt-8 mb-8">
      {interviews?.length > 0 &&
        interviews
          .sort((a, b) => a.sort - b.sort)
          .map((interview, index) => (
            <div
              onMouseEnter={() => setIsHoveredIndex(index)}
              onMouseLeave={() => setIsHoveredIndex(null)}
              key={index}
              className={`w-full h-[250px] bg-white rounded-xl border border-primary2 p-6 flex flex-col
                ${
                  interview.active
                    ? "hover:border-primary transition-all duration-300 hover:scale-105"
                    : "hover:border-[#C1C1C1]"
                }
                ${
                  interview.id === "AiInterview"
                    ? "relative before:absolute before:inset-0 before:-z-10 before:animate-border-glow before:bg-gradient-conic before:rounded-xl before:p-[3px] before:opacity-0 before:opacity-10"
                    : ""
                }`}
              style={
                interview.id === "AiInterview"
                  ? { background: "white" }
                  : { boxShadow: "0px 0px 60px 7px rgba(0,0,0,0.07)" }
              }
            >
              <div className="flex items-center gap-3 mb-3">
                <p className="flex text-xl h-10 w-10 p-2 justify-center items-center bg-black text-white rounded-full">
                  {interview?.icon}
                </p>
                <h1 className="text-lg font-semibold">{interview?.title}</h1>
              </div>

              <p className="text-sm text-text_color4 mb-4 flex-grow">
                {interview?.description}
              </p>

              <div className="mt-auto">
                <button
                  className={`transition-all duration-500 ease-in-out text-black hover:text-white hover:bg-primary hover:border-primary text-sm md:text-md border border-black rounded-lg px-6 py-2 bg-white `}
                  onClick={() => {
                    if (interview.id === "mcq") {
                      navigate("/dashboard/mocktest");
                      return;
                    }
                    if (interview.id === "resumeSort") {
                      navigate("/dashboard/resume-analyzer");
                      return;
                    }
                    localStorage.removeItem("customSettings");
                    localStorage.removeItem("interviewDetails");
                    localStorage.removeItem("location");
                    settingPopup();
                    settingProInterview(index, interview?.id);
                  }}
                >
                  Start
                </button>
              </div>
            </div>
          ))}
    </div>
  );
}

export function TopCandidates({ data }) {
  const { CommonStore, UserStore } = useStores();

  let hiredCandidates = UserStore.bestPerformers;

  try {
    hiredCandidates = JSON.parse(hiredCandidates);
  } catch (error) {
    hiredCandidates = [];
  }

  const formatName = (name) => {
    if (!name) return "";

    // Capitalize each word
    const capitalizedName = name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    if (window.innerWidth > 1299) {
      // Truncate to 15 characters and append dots if necessary
      return capitalizedName.length > 12
        ? capitalizedName.substring(0, 12) + "..."
        : capitalizedName;
    } else {
      // Show only the first name
      const firstName = capitalizedName.split(" ")[0];
      return firstName.length > 10
        ? firstName.substring(0, 10) + "..."
        : firstName;
    }
  };

  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";

  return useObserver(() => (
    <>
      {hiredCandidates && UserStore?.bestPerformers2.length > 0 && (
        <div className="mt-[10%] md:mt-[1%]">
          <p className="font-semibold text-xl lg:text-2xl">
            <span className="text-primary">Top</span> Rankers
          </p>
          <div className="flex relative overflow-x-auto flex-nowrap gap-x-4 py-[5%] md:py-[3%] justify-start scrollbar-hide no-scrollbar">
            {UserStore?.bestPerformers2.map((candidate, index) => (
              <div
                key={index}
                className={`flex-none interviewshadow rounded-3xl p-2 py-4 lg:p-5 flex flex-col justify-center items-center w-[150px] lg:w-[180px] ${
                  index === 0 ? "bg-primary" : ""
                }`}
              >
                {index === 0 && (
                  <img
                    src={cup}
                    alt="cup"
                    width={50}
                    className="absolute left-0 top-5"
                  />
                )}
                <p className="text-white text-sm mb-2">Best performer</p>
                <img
                  src={candidate?.pic || defaultProfile}
                  alt={candidate?.name}
                  className={
                    `w-[50px] h-[50px] lg:w-[65px] border-[1px] lg:h-[65px] interviewshadow cursor-pointer rounded-full object-cover mb-2 ` +
                    (index === 0 ? "border-white" : "border-primary")
                  }
                />
                <p
                  className={`text-center font-medium text-base mb-1 ${
                    index === 0 ? "text-black" : ""
                  }`}
                >
                  {formatName(candidate?.name)}
                </p>
                <h6
                  className={`text-center text-sm text-primary ${
                    index === 0 ? "text-white" : ""
                  }`}
                >
                  {candidate?.overallRating}
                </h6>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  ));
}

export function HiredCandidates({ data }) {
  const { CommonStore, UserStore } = useStores();

  let hiredCandidates = UserStore.hiredCandidates;

  try {
    hiredCandidates = JSON.parse(hiredCandidates);
  } catch (error) {
    hiredCandidates = [];
  }

  const formatName = (name) => {
    if (!name) return "";

    // Capitalize each word
    const capitalizedName = name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    if (window.innerWidth > 1299) {
      // Truncate to 15 characters and append dots if necessary
      return capitalizedName.length > 12
        ? capitalizedName.substring(0, 12) + "..."
        : capitalizedName;
    } else {
      // Show only the first name
      const firstName = capitalizedName.split(" ")[0];
      return firstName.length > 10
        ? firstName.substring(0, 10) + "..."
        : firstName;
    }
  };
  const [filterOpen, setFilterOpen] = useState(false);
  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";

  return (
    <>
      {hiredCandidates && (
        <div className="mt-[10%] md:mt-[5%] lg:mt-[4%] px-[5%] md:px-0">
          <div className="md:flex-row lg:flex-row flex w-full flex-col items-center justify-between px-[5%] ">
            <p className="font-semibold text-xl lg:text-2xl md:px-[2%]">
              <span className="text-primary">Hired</span> Candidates
            </p>
          </div>
          <div className="flex relative overflow-x-auto flex-nowrap gap-x-4 py-[5%] md:py-[3%] md:px-[2%] justify-start scrollbar-hide no-scrollbar">
            {hiredCandidates.map((candidate, index) => (
              <div
                key={index}
                className={`flex-none interviewshadow rounded-3xl p-2 py-4 lg:p-5 flex flex-col justify-center items-center w-[150px] lg:w-[180px] ${
                  index === 0 ? "bg-primary" : ""
                }`}
              >
                {index === 0 && (
                  <img
                    src={cup}
                    alt="cup"
                    width={50}
                    className="absolute -left-3 top-0 md:left-5 md:top-5 lg:top-7"
                  />
                )}
                <p className="text-white text-sm mb-2">Best performer</p>
                <img
                  src={candidate?.userId?.pic || defaultProfile}
                  alt={candidate?.userId?.name}
                  className={`w-[50px] h-[50px] lg:w-[65px] lg:h-[65px] interviewshadow cursor-pointer rounded-full object-cover mb-2`}
                />
                <p
                  className={`text-center font-medium text-base mb-1 ${
                    index === 0 ? "text-black" : ""
                  }`}
                >
                  {formatName(candidate?.userId?.name)}
                </p>
                <p
                  className={`text-center font-semibold text-sm mb-1 ${
                    index === 0 ? "text-white" : "text-gray-400"
                  }`}
                >
                  {candidate?.recruiter?.companyName}
                </p>
                <h6
                  className={`text-center text-sm text-gray-400 ${
                    index === 0 ? "text-white" : ""
                  }`}
                >
                  as a {candidate?.jobPostId?.jobTitle}
                </h6>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
